import React from 'react'

export interface ChoiceFieldsetValidationProps {
  validationKey: string
}

const ChoiceFieldsetValidation: React.FC<ChoiceFieldsetValidationProps> = ({children}) => <>{children}</>

export default ChoiceFieldsetValidation
